import { ArticleMeta } from '../types/article';

export const articles: ArticleMeta[] = [
  {
    id: '103rd-national-high-school-soccer-championship-member-ranking',
    title: '【第103回全国高校サッカー選手権】代表48校の所属リーグと部員数ランキング（独自調査）',
    description: '第103回全国高校サッカー選手権大会に出場する48校の出場回数、所属リーグ、部員数をまとめました。部員数は独自調査のため、誤差があるかもしれません。',
    youtubeUrl: 'https://youtu.be/eJNGjUCEHOw',
    youtubeTitle: '【第103回全国高校サッカー選手権】代表48校の所属リーグと部員数ランキング',
    tags: ['高校サッカー選手権', '高校サッカー', '部員数', '第103回', 'ランキング'],
    category: 'ranking',
    publishedAt: '2025-01-17',
    updatedAt: '2025-01-17',
    thumbnail: '/images/103rd-national-high-school-soccer-championship-member-ranking.jpg',
    seoTitle: '【第103回全国高校サッカー選手権】代表48校の所属リーグと部員数ランキング | サッカーダッシュボード',
    seoDescription: '第103回全国高校サッカー選手権大会に出場する48校の出場回数、所属リーグ、部員数を独自調査でランキング形式で紹介。'
  },
  {
    id: '103rd-national-high-school-soccer-championship-j-league-players-ranking',
    title: '【第103回全国高校サッカー選手権】出場校別 現役Ｊリーガー数（独自調査）',
    description: '第103回高校サッカー選手権大会に出場する48校について、高校別に現役Jリーガー数を調査しました。',
    youtubeUrl: 'https://youtu.be/872p-Ba8pw8',
    youtubeTitle: '【第103回全国高校サッカー選手権】出場校別 現役Ｊリーガー数ランキング',
    tags: ['高校サッカー選手権', 'Jリーグ', 'ランキング', '第103回', 'Jリーガー'],
    category: 'ranking',
    publishedAt: '2025-01-18',
    updatedAt: '2025-01-18',
                    thumbnail: '/images/103rd-j-league-players-ranking.jpg',
    seoTitle: '【第103回全国高校サッカー選手権】出場校別 現役Ｊリーガー数ランキング | サッカーダッシュボード',
    seoDescription: '第103回高校サッカー選手権大会に出場する48校について、高校別に現役Jリーガー数を調査したランキングを紹介。'
  },
  {
    id: '103rd-national-high-school-soccer-championship-tournament-results-ranking',
    title: '【第103回高校サッカー選手権】出場校別 大会通算＆最高成績（独自調査）',
    description: '第103回全国高校サッカー選手権に出場する48校について、出場校別の通算成績と最高成績、出場回数、所属リーグをまとめました。',
    youtubeUrl: 'https://youtu.be/yPDykBD2uq8',
    youtubeTitle: '【第103回高校サッカー選手権】出場校別 大会通算＆最高成績ランキング',
    tags: ['高校サッカー選手権', '高校サッカー', 'ランキング', '第103回', '大会成績'],
    category: 'ranking',
    publishedAt: '2025-01-19',
    updatedAt: '2025-01-19',
    thumbnail: '/images/103rd-tournament-results-ranking.jpg',
    seoTitle: '【第103回高校サッカー選手権】出場校別 大会通算＆最高成績ランキング | サッカーダッシュボード',
    seoDescription: '第103回全国高校サッカー選手権に出場する48校について、出場校別の通算成績と最高成績、出場回数、所属リーグをまとめたランキングを紹介。'
  }
];

export const getArticleById = (id: string): ArticleMeta | undefined => {
  return articles.find(article => article.id === id);
};

export const getArticlesByCategory = (category: string): ArticleMeta[] => {
  return articles.filter(article => article.category === category);
};

export const getArticlesByTag = (tag: string): ArticleMeta[] => {
  return articles.filter(article => article.tags.includes(tag));
};
